import styled from 'styled-components'

import { IButton } from './globals.types'

export const Button = styled.button<IButton>``
